import {Injectable, OnDestroy} from '@angular/core';
import {CommunicationContentModelModel} from '../../api/entity/communicationContentModel.model';
import {AbstractFindAllService} from '../../../../core/service/v2/service/findAll/abstractFindAll.service';
import {CommunicationContentModelRepository} from './ngrx/communicationContentModel.repository';
import {CommunicationContentModelDataServiceAdapter} from './ngrx/communicationContentModelDataService.adapter';

@Injectable()
export class CommunicationContentModelFindAllService
    extends AbstractFindAllService<CommunicationContentModelModel, CommunicationContentModelModel>
    implements OnDestroy{

    constructor(repository: CommunicationContentModelRepository, dataServiceAdapter: CommunicationContentModelDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
    ngOnDestroy(): void {
        super.onDestroy();
    }
}
